import * as Sentry from '@sentry/vue'
import { type App } from 'vue'
import { environment } from './utils'

export const SentryInit = (app: App) => {
    /* istanbul ignore next */
    if (import.meta.env.VUE_APP_SENTRY_DSN) {
        Sentry.init({
            app,
            dsn: import.meta.env.VUE_APP_SENTRY_DSN,
            release: `teach@${import.meta.env.VUE_APP_VERSION}`,
            environment,
            beforeSend: (event, hint) => {
                const originalException = hint?.originalException as Error | string
                if (
                    originalException
                    && (
                        originalException.toString().includes('Invalid session token')
                        || originalException.toString().includes('Unable to connect to the Parse API')
                        || originalException.toString().includes('window.webkit.messageHandlers')
                        || originalException.toString().includes('ceCurrentVideo.currentTime')
                        || originalException.toString().includes('instantSearchSDKJSBridgeClearHighlight')
                    )
                ) {
                    return null
                }

                return event
            },
        })
    }
}
